import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";

interface LoadingProps {
    message?: string;
}

function Loading(props: LoadingProps) {
    const { message = "Processing..." } = props;

    return (
        <Backdrop
            sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={true}
        >
            <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                <CircularProgress color="inherit" />
                <Typography variant="h6" color="inherit">
                    {message}
                </Typography>
            </Box>
        </Backdrop>
    );
}

export default Loading;